<template>
  <v-dialog
    max-width="600"
    :value="value.show"
    persistent
    @keydown.esc="cancel()"
  >
    <v-card tile v-if="value.show">
      <v-app-bar flat dark color="primary">
        <v-btn icon dark @click="cancel()">
          <v-icon>close</v-icon>
        </v-btn>
        <span class="title"
          >{{ resx.labels.changePassword }} - {{ value.user.username }}</span
        >
      </v-app-bar>
      <form name="changePasswordFrm" @submit.prevent="save()" novalidate>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row wrap>
              <v-col xs12>
                <v-text-field
                  :append-icon="
                    passwordVisible ? 'visibility' : 'visibility_off'
                  "
                  :append-icon-cb="() => (passwordVisible = !passwordVisible)"
                  data-vv-name="newPassword"
                  :data-vv-as="resx.labels.newPassword"
                  :label="resx.labels.newPassword"
                  :error-messages="errors.collect('newPassword')"
                  v-model="value.password"
                  :type="!passwordVisible ? 'password' : 'text'"
                  v-validate="'required'"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancel()">{{ resx.labels.cancel }}</v-btn>
          <v-btn class="primary" type="submit" :disabled="!isValidForm">{{
            resx.labels.ok
          }}</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import { EventBus } from "@/bus";
import userService from "@/services/UserService";

const CHANGE_ADMIN_PASSWORD_CANCEL = "changeAdminPasswordCancel";
const CHANGE_ADMIN_PASSWORD_SAVE = "changeAdminPasswordSave";

const mixin = {
  data() {
    return {
      changePasswordData: {
        show: false,
        user: null,
        password: null
      }
    };
  },
  methods: {
    changePasswordOpen: function(user) {
      const vm = this;
      this.changePasswordData.show = true;
      this.changePasswordData.user = user;
      this.changePasswordData.password = null;
      return new Promise((resolve, reject) => {
        EventBus.$once(CHANGE_ADMIN_PASSWORD_SAVE, () => {
          vm.changePasswordClose();
          resolve();
        });
        EventBus.$once(CHANGE_ADMIN_PASSWORD_CANCEL, () => {
          vm.changePasswordClose();
          reject();
        });
      });
    },
    changePasswordClose: function() {
      this.changePasswordData.show = false;
      this.changePasswordData.password = null;
      this.changePasswordData.user = null;
    }
  }
};

export default {
  name: "admin-change-password",
  data() {
    return {
      passwordVisible: false
    };
  },
  methods: {
    async save() {
      const result = await userService.changePassword(
        this.value.user._id,
        this.value.password
      );
      if (result) {
        this.passwordVisible = false;
        EventBus.$emit(CHANGE_ADMIN_PASSWORD_SAVE);
      }
    },
    cancel() {
      this.passwordVisible = false;
      EventBus.$emit(CHANGE_ADMIN_PASSWORD_CANCEL);
    }
  },
  props: ["value"]
};

export { mixin };
</script>
